module.exports = __webpack_public_path__ + "img/01_bohle.4db08db2.jpeg";